<template>
  <!-- 服务请求 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">服务请求</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div
        v-for="(info, index) in serviceInfo"
        :key="index"
        class="d-flex mb-3"
      >
        <label class="info-label">{{ info.label }}</label>
        <div class="flex-1">
          <span
            v-if="index == 0 || index == 4"
            :class="[
              'badge',
              index == 0 ? statusColor[info.value] : priorityColor[info.value],
            ]"
            >{{
              index == 0 ? filterStatus(info.value) : filterPriority(info.value)
            }}</span
          >
          <span v-else>{{ info.value }}</span>
        </div>
      </div>
      <div class="border-top">
        <div class="d-flex justify-content-end mt-2">
          <button
            type="button"
            class="btn btn-outline-danger waves-effect waves-light me-3"
            @click="closeService"
          >
            关闭请求
          </button>
          <button
            type="button"
            class="btn btn-primary waves-effect waves-light"
            @click="handlerJump"
          >
            创建工单
          </button>
        </div>
      </div>
    </b-card-body>
  </div>
  <!-- 联系人 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">联系人</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div class="d-flex mb-3">
        <div class="user-img me-3">
          <img :src="userInfo.img" alt="" />
        </div>
        <div class="user-base d-flex flex-column justify-content-between">
          <div class="user-name fw-bold">{{ userInfo.name }}</div>
          <div class="user-role text-muted">{{ userInfo.role }}</div>
        </div>
      </div>
      <div class="user-phone mb-1 d-flex align-items-center">
        <i class="ri-phone-line me-3 fs-4 text-muted"></i>
        <span>{{ userInfo.phone }}</span>
      </div>
      <div class="user-email d-flex align-items-center">
        <i class="ri-mail-line me-3 fs-4 text-muted"></i>
        <span> {{ userInfo.email }}</span>
      </div>
    </b-card-body>
  </div>
  <!-- 公司信息 -->
  <div class="card flex-1 overflow-auto">
    <b-card-body>
      <div class="company-base d-flex flex-column align-items-center mb-3">
        <div class="company-icon mb-2">
          <img :src="companyInfo.logo" alt="" />
        </div>
        <div class="company-name fw-bold">{{ companyInfo.name }}</div>
      </div>
      <div class="company-detail">
        <div class="d-flex mb-3">
          <label class="info-label">行业</label>
          <div class="flex-1">{{ companyInfo.industry }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">联系电话</label>
          <div class="flex-1">{{ companyInfo.tel }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">电子邮箱</label>
          <div class="flex-1">{{ companyInfo.email }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">官方网站</label>
          <div class="flex-1">{{ companyInfo.home_url }}</div>
        </div>
        <div class="d-flex">
          <label class="info-label">公司地址</label>
          <div class="flex-1">{{ companyInfo.address }}</div>
        </div>
      </div>
    </b-card-body>
  </div>
</template>

<script>
import {
  priorityColor,
  statusColor,
  filterStatus,
  filterPriority,
  serviceInfo,
} from "../data.js";
import moment from "moment";
import _ from "lodash";
import { customerDetail, patchRepairService } from "@/service/index";
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["initDetailInfo"],
  data() {
    return {
      priorityColor,
      statusColor,
      serviceInfo,
      userInfo: {
        img: require("@/assets/user-img.svg"),
        name: "李建国",
        role: "设备部经理",
        phone: "18567891234",
        email: "example@example.com",
      },
      companyInfo: {
        // logo: require("@/assets/company-icon.svg"),
      },
    };
  },
  watch: {
    detailInfo: {
      handler(val) {
        if (val) {
          this.filterServiceInfo();
          this.filterUserInfo();
          this.filterCompanyInfo();
          this.getCustomerInfo(val.customer);
        }
      },
      deep: true,
    },
  },
  methods: {
    moment,
    filterStatus,
    filterPriority,
    filterServiceInfo() {
      this.serviceInfo[0].value = this.detailInfo.status;
      this.serviceInfo[1].value = this.detailInfo.type_txt;
      this.serviceInfo[2].value = moment(this.detailInfo.created_at).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.serviceInfo[3].value = moment(this.detailInfo.expectation_at).format(
        "YYYY-MM-DD"
      );
      this.serviceInfo[4].value = this.detailInfo.priority;
    },
    filterUserInfo() {
      this.userInfo.name = this.detailInfo.customer_contact;
      this.userInfo.phone = this.detailInfo.customer_contact_number;
    },
    filterCompanyInfo() {
      //  todo filter company info
    },
    getCustomerInfo(id) {
      customerDetail(id).then((res) => {
        if (res && res.payload) {
          let detail = res.payload;
          this.companyInfo = _.merge(this.companyInfo, detail);
        }
      });
    },
    closeService() {
      let id = this.detailInfo.id;
      let params = {
        status: "3",
      };
      patchRepairService(id, params).then((res) => {
        if (res && res.payload) {
          this.$emit("initDetailInfo");
        }
      });
    },
    handlerJump() {
      this.$router.push({
        path: "/work-order-add",
        query: {
          id: this.detailInfo.id,
        },
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.info-label {
  width: 30%;
  margin-right: 20px;
  margin-bottom: 0;
}
.user-img {
  width: 50px;
  height: 50px;
}
.company-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
</style>
